// The sections area: "Section Metrics" controls, the lazy sections chart, the metrics table
// and the expandable detail cards (sections_block.coffee composition; the cards render
// whenever the area is expanded — the coffee block never gated sub_items on a component flag).

import PropTypes from 'prop-types'
import { answerPropType } from '@aytm/app/stats/page/question-views/components/lib/prop-types'

import { isNoneChartMode } from '@aytm/app/stats/page/question-views/components/lib/chart-modes'
import { isComponentOn } from '@aytm/app/stats/page/question-views/components/lib/utils'
import ChartPlaceholder from '@aytm/app/stats/page/question-views/components/charts/placeholders/Chart'
import Table from '@aytm/app/stats/components/data-views/table/components/Table'

import SectionMetricsControls from '@aytm/app/stats/page/question-views/mn/components/sections-section/SectionMetricsControls'
import SectionsChart from '@aytm/app/stats/page/question-views/mn/components/sections-section/chart/SectionsChart'
import SectionCards from '@aytm/app/stats/page/question-views/mn/components/sections-section/section-cards/SectionCards'
import { calcSectionsTable } from '@aytm/app/stats/page/question-views/mn/components/sections-section/lib/sectionsTable'
import { SECTION_VIEW_OPTIONS } from '@aytm/app/stats/page/question-views/mn/lib/viewOptions'

const SectionsSection = ({
  id,
  components,
  answer,
  image,
  sections,
  priceTemplate,
  isAnimated,
  sectionsViewMode,
  sectionsCollapsed,
  chartMode,
  globalChartMode,
  unCollapsedSections,
  tableProps,
  chartProps,
  onModelChange,
  onToggle,
  onSectionCardToggle,
  onSectionCardsToggleAll
}) => (
  <>
    {isComponentOn(components, 'controls') && (
      <SectionMetricsControls
        title="Section Metrics"
        options={SECTION_VIEW_OPTIONS}
        viewMode={sectionsViewMode}
        collapsed={sectionsCollapsed}
        onModelChange={onModelChange}
        onToggle={onToggle}
      />
    )}
    {!sectionsCollapsed && (
      <>
        {isComponentOn(components, 'chart') && !isNoneChartMode(chartMode, globalChartMode) && (
          <ChartPlaceholder isLoading={'loading' === answer} isAnimated={isAnimated}>
            {'loading' !== answer && (
              <SectionsChart viewMode={sectionsViewMode} sections={sections} answer={answer} {...chartProps} />
            )}
          </ChartPlaceholder>
        )}
        {isComponentOn(components, 'table') && <Table {...calcSectionsTable(tableProps)} />}
        <SectionCards
          sections={sections}
          answer={answer}
          image={image}
          questionId={id}
          priceTemplate={priceTemplate}
          components={components}
          unCollapsedSections={unCollapsedSections}
          onSectionCardToggle={onSectionCardToggle}
          onSectionCardsToggleAll={onSectionCardsToggleAll}
        />
      </>
    )}
  </>
)

SectionsSection.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  components: PropTypes.object,
  answer: answerPropType,
  image: PropTypes.object,
  sections: PropTypes.array,
  priceTemplate: PropTypes.string,
  isAnimated: PropTypes.bool,
  sectionsViewMode: PropTypes.string,
  sectionsCollapsed: PropTypes.bool,
  chartMode: PropTypes.string,
  globalChartMode: PropTypes.string,
  unCollapsedSections: PropTypes.array,
  tableProps: PropTypes.object,
  chartProps: PropTypes.object,
  onModelChange: PropTypes.func,
  onToggle: PropTypes.func,
  onSectionCardToggle: PropTypes.func,
  onSectionCardsToggleAll: PropTypes.func
}

SectionsSection.displayName = 'SectionsSection'

export default SectionsSection
